






































import { Component, Prop } from 'vue-property-decorator';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';
import { PaymentMethodOption } from '@activities/interfaces/activity';

@Component({
  name: 'bpc-payment-method-accordion-v2',
  components: {
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class PaymentMethodAccordionV2 extends Vue {
  @Prop(String) readonly value: string;
  @Prop(Boolean) readonly disabled: boolean;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly paymentMethodOptions: PaymentMethodOption[];

  get model(): string {
    return this.value;
  }

  set model(value: string) {
    this.$emit('input', value);
  }

  onClickPaymentMethod(index: number) {
    this.$root.$emit('bv::toggle::collapse', 'accordion' + index);
  }
}
